<template>
    <div>
        <AddToCart v-if="showAddProductModal" v-on:close="closeAddToCartModal()"/>
        <div class="product-box">
            <img :src="product.thumbnail" :alt="product.title" class="product-box-image">
            <div class="product-box-info">
                <div class="product-box-title" v-html="product.title"></div>
                <div class="product-box-price">{{ product.price ? product.price : 'від ' + product.price_30 }} грн</div>
                <div class="product-box-description">
                    <span v-if="product.weight_30 > 0 || product.weight_50 > 0" class="product-box-description__weight">{{
                            product.weight_30 ? product.weight_30 : product.weight_50
                        }} г – </span>
                    {{ product.description }}
                </div>

                <button class="add-to-card-button" @click="showAddToCardModal()">В кошик</button>
            </div>
        </div>
    </div>
</template>

<script>
import AddToCart from '@/components/AddToCart.vue'

export default {
    components: {
        AddToCart
    },
    name: 'Product',
    props: {
        product: Object,
    },
    data() {
        return {
            showAddProductModal: false
        }
    },

    methods: {
        showAddToCardModal() {
            window.scrollTo(0, 0);
            let product = JSON.parse(JSON.stringify(this.product));
            this.$store.commit('setCurrentProduct', product);

            document.querySelector('body').style.overflow = 'hidden';
            this.showAddProductModal = true;
        },

        closeAddToCartModal() {
            document.querySelector('body').style.overflow = '';
            this.showAddProductModal = false;
        }
    }
}
</script>

<style>
.product-box {
    position: relative;
    overflow: hidden;

    width: 100%;
    max-width: 280px;
    min-width: 280px;
    height: 360px;

    margin-right: 14px;
    margin-bottom: 14px;
    padding: 14px;
    border: 1px solid white;
    border-radius: 8px;
}

.product-box:hover {
    box-shadow: 0 2px 40px 0 rgba(0, 0, 0, .12);
}

.product-box-image {
    width: 100%;
    border-radius: 8px;
}

.product-box-title {
    font-size: 1.2rem;
    font-weight: 700;
    text-align: center;
}

.product-box-price {
    font-size: 1.2rem;
    font-weight: bold;
    color: #AB2321;
}

.product-box-description {
    margin-top: 7px;

    font-size: 0.8rem;
    text-align: center;
}

.product-box-description__weight {
    color: #AB2321;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
}

.add-to-card-button {
    margin-top: 12px;
    padding: .375rem .75rem;
    border: 1px solid #AB2321;

    background-color: #AB2321;
    color: #fff;
    border-radius: 6px;
}

.product-box-info {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    min-height: 160px;
    padding: 4px 14px 14px 14px;

    box-shadow: 0 -5px 15px rgb(255 255 255);
    background: rgba(255,255,255,0.9);
}

@media only screen and (max-width: 1024px) {
    .product-box {
        width: 100%;
        max-width: 100%;
        padding: 0px;
        margin: 0px;
        margin-bottom: 34px;
        border: 1px solid #eee;
    }

    .product-box-image {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    .product-box-info {
        padding-left: 14px;
        padding-right: 14px;
        padding-bottom: 14px;
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}

.dark {
    .product-box-info {
        box-shadow: 0 -5px 15px #262323;
        background: rgba(38,35,35,0.9);
    }
}
</style>
